import { render, staticRenderFns } from "./PolizaDatosGenerales.vue?vue&type=template&id=217f6e00&scoped=true"
import script from "./PolizaDatosGenerales.vue?vue&type=script&lang=js"
export * from "./PolizaDatosGenerales.vue?vue&type=script&lang=js"
import style0 from "./PolizaDatosGenerales.vue?vue&type=style&index=0&id=217f6e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f6e00",
  null
  
)

export default component.exports